/**
 * This file exposes the print preview as a separate template.
 */

import { Link } from '@react-pdf/renderer';
import React from 'react';
import {
  Page,
  // Stencil,
  Text,
  Title,
} from '../../pdf-design-system';
import WineGBCatalog, { PageBody, theme, useBleed } from './WineGBCatalog';

/**
 * Instead of exporting all the components to another file, we export just this function and afterQuery.
 * @param {*} param0
 * @returns
 */
export default function WineGBCatalogPrintPreview({
  data,
  locale,
  options = { bleed: 0 },
  ...rest
}) {
  return (
    <WineGBCatalog
      data={data}
      locale={locale}
      options={options}
      // We pass in the template we want to use
      preview={PrintPreview}
      {...rest}
    />
  );
}

/**
 * The print preview page includes tips and tricks to help the exhibitor create a nicer page.
 * @param {*} param0
 * @returns
 */
export function PrintPreview({ registration, options, locale, ...rest }) {
  const { withBleed } = useBleed(options);

  return (
    <Page
      size={{ width: withBleed(148, 2), height: withBleed(210, 2) }}
      style={[
        { paddingVertical: withBleed(0), paddingHorizontal: withBleed(0) },
      ]}
      theme={theme}
      {...rest}
    >
      <CatalogTipsAndTricks
        registration={registration}
        style={{ marginVertical: '1cm' }}
      />
    </Page>
  );
}

function CatalogTipsAndTricks({ registration, ...rest }) {
  return (
    <PageBody {...rest}>
      <Title style={{ color: theme.colors.primary }}>Tips & Tricks</Title>
      <Text>
        This guide explains how to make your catalogue page as attractive as
        possible.
      </Text>
      <Title
        variant="small"
        style={{ marginTop: 10, color: theme.colors.primary }}
      >
        Profile picture
      </Title>
      <Text>
        Make sure your profile picture is in landscape format.{' '}
        <Link
          style={{ color: theme.colors.primary }}
          src={`https://app.bottlebooks.me/dashboard/app/events/${registration.collection.collectionId}/exhibitors/${registration.companyId}/profile`}
        >
          Change image.
        </Link>
      </Text>
      <Title
        variant="small"
        style={{ marginTop: 10, color: theme.colors.primary }}
      >
        Line breaks are automatically removed
      </Title>
      <Text>
        Any line breaks in your company description have been romoved. This
        helps fit as much text into the space availabe.
      </Text>
      <Title
        variant="small"
        style={{ marginTop: 10, color: theme.colors.primary }}
      >
        Bottle pictures with white background
      </Title>
      <Text>
        Bottle images should be placed against either a white or transparent
        background. background.{' '}
        <Link
          style={{ color: theme.colors.primary }}
          src={`https://app.bottlebooks.me/dashboard/app/events/${registration.collection.collectionId}/exhibitors/${registration.companyId}/products`}
        >
          Update product images.
        </Link>
      </Text>
    </PageBody>
  );
}

WineGBCatalogPrintPreview.fragment = WineGBCatalog.fragment;
